import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M11.38 6.39V4.28a3 3 0 0 0-3-3h-.75a3 3 0 0 0-3 3v2.11A2.75 2.75 0 0 0 2 9.14V12a2.75 2.75 0 0 0 2.7 2.75h6.61A2.75 2.75 0 0 0 14.06 12V9.14a2.75 2.75 0 0 0-2.68-2.75ZM6.13 4.28a1.5 1.5 0 0 1 1.5-1.5h.75a1.5 1.5 0 0 1 1.5 1.5v2.11H6.13ZM12.56 12a1.25 1.25 0 0 1-1.25 1.25H4.7A1.25 1.25 0 0 1 3.45 12V9.14A1.25 1.25 0 0 1 4.7 7.89h6.61a1.25 1.25 0 0 1 1.25 1.25Z';
const draw24px =
  'M17.08,10.18h-.82v-3a3.75,3.75,0,0,0-3.75-3.75h-1A3.75,3.75,0,0,0,7.76,7.13v3.05H6.94a2.75,2.75,0,0,0-2.75,2.75v5.14a2.75,2.75,0,0,0,2.75,2.75H17.08a2.75,2.75,0,0,0,2.75-2.75V12.93A2.75,2.75,0,0,0,17.08,10.18Zm-7.82-3a2.25,2.25,0,0,1,2.25-2.25h1a2.25,2.25,0,0,1,2.25,2.25v3.05H9.26Zm9.07,10.94a1.25,1.25,0,0,1-1.25,1.25H6.94a1.25,1.25,0,0,1-1.25-1.25V12.93a1.25,1.25,0,0,1,1.25-1.25H17.08a1.25,1.25,0,0,1,1.25,1.25Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const LockIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'lock'),
) as IconWithRender;

LockIcon.displayName = 'LockIcon';
LockIcon.propTypes = Icon.propTypes;
LockIcon.renderIcon = (props) => <LockIcon {...props} />;
export default LockIcon;
